import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import driverLoadApi from '../../../../../api/driverLoads/driverLoadsApi';
import { IDriverLoadWithContacts } from '../../../../../api/driverLoads/interfaces/IDriverLoadWithContacts';

export const fetchDriverLoadContacts = createAsyncThunk(
    'driverLoadContacts/fetchDriverLoadContacts',
    async (shipmentId: number, { rejectWithValue }) => {
        try {
            const response = await driverLoadApi.fetchDriverLoadContacts(
                shipmentId,
            );
            return response;
        } catch {
            return rejectWithValue('Error');
        }
    },
);

export interface IDriverLoadContactsState {
    contacts: IDriverLoadWithContacts[];
    loading: boolean;
}

const initialState: IDriverLoadContactsState = {
    contacts: [],
    loading: false,
};

const driverLoadContactsSlice = createSlice({
    name: 'driverLoadContacts',
    initialState,
    reducers: {
        clearDriverLoadContacts: state => {
            state.contacts = [];
        },
        setDriverLoadContacts: (
            state,
            action: PayloadAction<IDriverLoadWithContacts[]>,
        ) => {
            state.contacts = action.payload;
        },
    },
    extraReducers: builder => {
        builder
            .addCase(fetchDriverLoadContacts.pending, state => {
                state.loading = true;
            })
            .addCase(fetchDriverLoadContacts.fulfilled, (state, action) => {
                state.loading = false;
                state.contacts = action.payload;
            })
            .addCase(fetchDriverLoadContacts.rejected, state => {
                state.loading = false;
            });
    },
});

export const { clearDriverLoadContacts, setDriverLoadContacts } =
    driverLoadContactsSlice.actions;

const driverLoadContactsReducer = driverLoadContactsSlice.reducer;
export default driverLoadContactsReducer;
